import './App.css';
import './responsive.css';
import Home from './pages/Home';
import Login from './pages/Login';
import Isjs2025 from './pages/Isjs2025';
import Asjs2025 from './pages/Asjs2025';
import Dashboard from './pages/Dashboard';
import Stallenquiryform from './pages/Stallenquiryform';

import { BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import Aboutpage from './pages/Aboutpage';
import Floorplan from './pages/Floorplan';
import Sponsership from './pages/Sponsership';
import Gallerypage from './pages/Gallery';
import Media from './pages/Media';
import Asjsbookingform from './pages/Asjsbookingform';
import Isjsbookingform from './pages/Isjsbookingform';
import Aijebookingform from './pages/Aijebookingform';
import Aboutpageisjs from './pages/Aboutpageisjs';
import Aboutpageasjs from './pages/Aboutpageasjs';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import Visitor from './pages/visitor';
import Exhibitorbadges from './pages/Exhibitorbadges';
import Exhibitordirectory from './pages/Exhibitordirectory';
import Electronicsurveillance from './pages/Electronicsurveillance';
import Saferental from './pages/Saferental';
import Standcleaningservices from './pages/Standcleaningservices';
import Hosthostesses from './pages/Hosthostesses';
import Exhibitorbranding from './pages/Exhibitorbranding';
import Stalllayout from './pages/Stalllayout';
import Extrafurniture from './pages/Extrafurniture';
import Stallallotmentletter from './pages/Stallallotmentletter';
import Sponsorshipopportunities from './pages/Sponsorshipopportunities';
import RefundPolicy from './pages/RefundPolicy';
import CancellationPolicy from './pages/CancellationPolicy';
import { HelmetProvider } from "react-helmet-async";

function App() {

  const checkIfUserIsLoggedIn = () => {
    return localStorage.getItem('user') !== null;

  }
  const isLoggedIn = checkIfUserIsLoggedIn();


  return (
    <div className="App">
       <HelmetProvider>
      <Router>
        <Routes>



          <Route path='/login' element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />} />
          <Route index element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/about' element={<Aboutpage />} />
          <Route path='/floorplan' element={<Floorplan />} />
          <Route path='/sponsership' element={<Sponsership />} />
          <Route path='/gallery' element={<Gallerypage />} />
          <Route path='/media' element={<Media />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/asjs2025' element={<Asjs2025 />} />
          <Route path='/isjs2025' element={<Isjs2025 />} />
          <Route path='/terms-and-condition' element={<Terms />} />
          <Route path='/privacy-policy' element={<Privacy />} />
          <Route path='/contact' element={<Contact />} />

          {/* <Route path='/stallenquiryform'  element={<Stallenquiryform/>}  /> */}
          <Route path='/roijaipur' element={<Stallenquiryform />} />

          <Route path='/asjs-booking-form' element={<Asjsbookingform />} />
          <Route path='/isjs-booking-form' element={<Isjsbookingform />} />

          <Route path='/about-isjs' element={<Aboutpageisjs />} />
          <Route path='/about-asjs' element={<Aboutpageasjs />} />

          <Route path='/visitor' element={<Visitor />} />
          <Route path='/exhibitor-badges' element={<Exhibitorbadges />} />
          <Route path='/exhibitor-directory' element={<Exhibitordirectory />} />
          <Route path='/electronic-surveillance' element={<Electronicsurveillance />} />
          <Route path='/safe-rental' element={<Saferental />} />
          <Route path='/stand-cleaning' element={<Standcleaningservices />} />
          <Route path='/host-hostesses' element={<Hosthostesses />} />
          <Route path='/exhibitor-branding' element={<Exhibitorbranding />} />
          <Route path='/stall-layout' element={<Stalllayout />} />
          <Route path='/extra-furniture' element={<Extrafurniture />} />
          <Route path='/stall-allotment' element={< Stallallotmentletter />} />
          <Route path='/sponsorship-opportunities' element={< Sponsorshipopportunities />} />
          <Route path='/refund-policy' element={< RefundPolicy />} />
          <Route path='/cancellation-policy' element={< CancellationPolicy />} />
          <Route path='/aije-booking-form' element={< Aijebookingform />} />
        </Routes>
      </Router>

</HelmetProvider>

    </div>
  );
}

export default App;
